export default function authHeader() {
  let user = JSON.parse(localStorage.getItem("user"));
  if (user && user.message.token) {
    return { Authorization: "Bearer " + user.message.token };
  } else {
    return {};
  }
}
